const handleOutsideClick = (e: MouseEvent, wrapper: Element) => {
  if (!wrapper.contains(e.target as Node)) {
    wrapper.classList.remove('active');
  }
};

const handleKeydown = (e: KeyboardEvent, wrapper: Element) => {
  if (e.key === 'Escape') {
    wrapper.classList.remove('active');
  }
};

const handleElementClick = (wrapper: Element) => {
  wrapper.classList.toggle('active');
};

const handleDropdownLink = (el: Element) => {
  const wrapper = el.closest('.nav-item--dropdown');

  if (!wrapper) {
    return;
  }

  el.addEventListener('click', () => handleElementClick(wrapper));
  document.addEventListener('click', (e) => handleOutsideClick(e, wrapper));
  document.addEventListener('keydown', (e) => handleKeydown(e, wrapper));
};

export const navLinkListener = () => {
  const dropdownLinks = document.querySelectorAll('.nav-link--dropdown');
  dropdownLinks.forEach((el) => handleDropdownLink(el));
};
